'use client'

import React from 'react'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu'
import { Button } from '../ui/button'
import { Globe } from 'lucide-react'
import { cn } from '@/utilities/ui'
import { useLanguage } from '@/providers/LanguageProvider'

const languageTranslations = {
  en: {
    english: 'English',
    french: 'French',
    arabic: 'Arabic',
    code: 'EN'
  },
  fr: {
    english: 'Anglais',
    french: 'Français',
    arabic: 'Arabe',
    code: 'FR'
  },
  ar: {
    english: 'الإنجليزية',
    french: 'الفرنسية',
    arabic: 'العربية',
    code: 'العربية'
  }
}

const LanguageButton = ({ className }: { className?: string }) => {
  const { language, setLanguage } = useLanguage()
  const t = languageTranslations[language as keyof typeof languageTranslations] || languageTranslations.en

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="destructive"
          size="sm"
          className={cn(
            '!min-w-fit bg-transparent shadow-none hover:bg-transparent !px-1 py-1 !w-fit text-secondary hover:shadow focus:shadow-none focus:!border-none focus:!outline-none focus:!ring-0 focus:!ring-offset-0 focus:!ring-transparent ',
            className,
          )}
        >
          <Globe className="text-white !h-6 lg:!h-5 !w-6 lg:!w-5" />
          <span className="ml-1 rtl:mr-1 text-white text-xs font-medium">
            {t.code}
          </span>
          <span className="sr-only">Toggle language</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => setLanguage('en')}>
          English
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setLanguage('fr')}>
          Français
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setLanguage('ar')}>
          العربية
        </DropdownMenuItem>
        
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default LanguageButton
